import React, { useContext } from "react";
import { toast } from "react-hot-toast";
import { Link, NavLink } from "react-router-dom";
import { AuthContext } from "../../../context/AuthProvider";

const Navbar = () => {
  const { user, userLogout } = useContext(AuthContext);

  const handleLogout = () => {
    userLogout()
      .then(() => {
        toast.success("Logout Successfully");
      })
      .catch((err) => console.log(err));
  };

  let activeStyle = {
    backgroundColor: "#fc0012",
    color: "#fff",
    borderRadius: "8px",
  };
  return (
    <div className="bg-[#fefefe] border-b">
      <div className="navbar py-4 max-w-6xl mx-auto flex justify-between">
        <div className="navbar-start">
          <div className="dropdown">
            <label tabIndex={0} className="btn btn-ghost lg:hidden">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M4 6h16M4 12h8m-8 6h16"
                />
              </svg>
            </label>
            <ul
              tabIndex={1}
              className="menu menu-compact dropdown-content mt-3 p-2 shadow bg-base-100 rounded-box w-52"
            >
              <li className="text-primary text-lg font-semibold lg:mr-5 ">
                <Link to="/" className="hover:text-[#0b163f]">
                  Home
                </Link>
              </li>
              <li className="text-primary text-lg font-semibold lg:mr-5">
                <Link to="/collection">Our Collection</Link>
              </li>
              <li className="text-primary text-lg font-semibold lg:mr-5">
                <Link to="/dashboard/add-product">Add Collection</Link>
              </li>
              {user?.uid && (
                <li className="text-primary hover:bg-transparent  text-lg font-semibold lg:mr-5 hover:text-primary">
                  <Link to="/dashboard">Dashboard</Link>
                </li>
              )}
              <li className="text-primary hover:bg-transparent  text-lg font-semibold lg:mr-5 hover:text-primary">
                <Link to="/blog">Blog</Link>
              </li>
            </ul>
          </div>

          <Link to="/" className="text-2xl font-bold text-primary uppercase ">
            car<span className="text-[#0b163f]">Dealer</span>
          </Link>
        </div>
        <div className=" hidden lg:flex">
          <ul className="menu menu-horizontal p-0">
            <li className="text-primary text-lg font-semibold lg:mr-5">
              
              <NavLink
                style={({ isActive }) => (isActive ? activeStyle : undefined)}
                to="/"
              >Home</NavLink>
            </li>

            <li className="text-primary text-lg font-semibold lg:mr-5">
              <NavLink
                style={({ isActive }) => (isActive ? activeStyle : undefined)}
                to="/collection"
              >Top Collection</NavLink>
            </li>

            <li className="text-primary text-lg font-semibold lg:mr-5">
              <NavLink
                style={({ isActive }) => (isActive ? activeStyle : undefined)}
                to="/dashboard/add-product"
              >Add Collection</NavLink>
            </li>

            {user?.uid && (
              <li className="text-primary hover:bg-transparent  text-lg font-semibold lg:mr-5 hover:text-primary">
                <NavLink
                style={({ isActive }) => (isActive ? activeStyle : undefined)}
                to="/dashboard"
              >Dashboard</NavLink>
              </li>
            )}
            <li className="text-primary hover:bg-transparent  text-lg font-semibold lg:mr-5 hover:text-primary">
            <NavLink
                style={({ isActive }) => (isActive ? activeStyle : undefined)}
                to="/blog"
              >Blog</NavLink>
            </li>
            {user?.uid ? (
              <button
                className="btn btn-primary text-white"
                onClick={handleLogout}
              >
                Logout
              </button>
            ) : (
              <Link
                to="/signin"
                className="btn btn-primary capitalize px-8 text-white"
              >
                SignIn
              </Link>
            )}
          </ul>
        </div>
        <label
          tabIndex={2}
          htmlFor="dashboard-drawer"
          className="btn btn-ghost lg:hidden"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-5 w-5"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M4 6h16M4 12h8m-8 6h16"
            />
          </svg>
        </label>
      </div>
    </div>
  );
};

export default Navbar;
